import { render, staticRenderFns } from "./subfolder-edit.vue?vue&type=template&id=284e819d"
import script from "./subfolder-edit.vue?vue&type=script&lang=js"
export * from "./subfolder-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports